export default [
  {
    key: 'actions',
    visible: true
  },
  {
    key: 'date',
    sortable: true,
    visible: true
  },
  {
    key: 'hours',
    label: 'Hours Lead Generated',
    sortable: true,
    visible: true
  },
  {
    key: 'dials',
    label: 'Dials Made',
    sortable: true,
    visible: true
  },
  {
    key: 'contacts',
    label: 'Contacts Made',
    sortable: true,
    visible: true
  },
  {
    key: 'listing_nurtures',
    label: 'Listings Nurtured',
    sortable: true,
    visible: true
  },
  {
    key: 'listings_set',
    label: 'Listing Appointments Set',
    sortable: true,
    visible: true
  },
  {
    key: 'listings_held',
    label: 'Listing Appointments Held',
    sortable: true,
    visible: true
  },
  {
    key: 'listings_taken',
    label: 'Listings Taken',
    sortable: true,
    visible: true
  },
  {
    key: 'listings_sold',
    label: 'Listings Sold',
    sortable: true,
    visible: true
  },
  {
    key: 'buyer_nurtures',
    label: 'Buyers Nurtured',
    sortable: true,
    visible: true
  },
  {
    key: 'buyers_set',
    label: 'Buyer Appointments Set',
    sortable: true,
    visible: true
  },
  {
    key: 'buyers_held',
    label: 'Buyer Appointments Held',
    sortable: true,
    visible: true
  },
  {
    key: 'buyers_signed',
    label: 'Buyers Signed',
    sortable: true,
    visible: true
  },
  {
    key: 'buyers_sold',
    label: 'Buyers Sold',
    sortable: true,
    visible: true
  },
  {
    key: 'price_correction',
    sortable: true,
    visible: true
  },
  {
    key: 'offers_written',
    sortable: true,
    visible: true
  }
];